/* OBJECTS */
import $ from 'jquery';
export default class Mobile {
  constructor() {}
  menu_action = () => {
    $('body').on('click', 'a.toggle-mnu', function (event) {
      event.preventDefault();
      var header_height = $('.header').outerHeight();
      if($(this).hasClass('on')) {
        $('.wrapper > .sidebar').css('top', 0);
      }else{
        $('.wrapper > .sidebar').css('top', header_height);
      }
      $('body').toggleClass('mobile-menu-opened');
      $(this).toggleClass('on');
    });
  }
  init = () => {
    this.menu_action();
  }
}
